import React, { FunctionComponent } from 'react';
import { Dropdown } from 'semantic-ui-react';
import { NavLink } from 'react-router-dom';
import withStyles from 'react-jss';

import { Profile } from 'components/UserMgmt/UserMgmt.helpers';
import ShowLogout from '../ShowLogout';
import styles from 'components/Header/components/SecondaryNav/SecondaryNav.styles';

import { ClassProp } from 'helpers/types';

type Styles = ClassProp<typeof styles>;

type Props = {
  classes: Styles;
  profile: Profile;
};

const InternalSubNav: FunctionComponent<Props> = ({ classes, profile }) => {
  const { givenName, familyName } = profile;

  return (
    <Dropdown
      item
      text={`${givenName} ${familyName}`}
      className={classes.dropDown}
    >
      <Dropdown.Menu className={classes.dropDownMenu}>
        <Dropdown.Item
          className={classes.logoutBtn}
          exact
          to="/sign-up"
          content="SignUp"
          as={NavLink}
        />
        <ShowLogout />
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default withStyles(styles)(InternalSubNav);
